module.exports = __webpack_public_path__ + "img/Wp_2008.8c1d712c.png";